import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { useAppMeta } from "hooks";
import { useCreatePaymentAccountMutation } from "store/services/PaymentsApi/paymentAccountApi";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import PaymentAccountForm from "./paymentAccountComponents/PaymentAccountForm";

const breadcrumbs = [
  { title: "Payment Accounts", path: "/app/crm/payment-account/list" },
  { title: "New Payment Account" },
];

const PaymentAccountCreateScreen = () => {
  const navigate = useNavigate();
  // RTK Query
  const [createPaymentAccount, { isLoading: creatingPaymentAccount }] =
    useCreatePaymentAccountMutation();

  // methods
  const handleCreatePayment = async (data) => {
    try {
      const { _id } = await createPaymentAccount(data).unwrap();
      toast.success("Payment Account successfully created!");
      navigate(`/app/crm/payment-account/${_id}/detail`);
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't create paymentAccount!");
    }
  };

  useAppMeta("New Payment Account");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingPaymentAccount}>
      <BreadcrumbLayout.Paper>
        <PaymentAccountForm
          onSubmit={handleCreatePayment}
          isBusy={creatingPaymentAccount}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default PaymentAccountCreateScreen;
